import { FC, useEffect, useState } from 'react';
import { api } from '../services/api';
import { toast } from '../hooks/use-toast';
import { useGamenics, GamenicsEvent } from '../hooks/useGamenics';
import { Icon } from './icons/Icon';

interface Props {
    creatorId?: string;
    myId?: string | null;
    isLoggedIn?: boolean;
}

// 応援フォロー（無料・フェーズA）。自分自身には表示しない。
export const FollowButton: FC<Props> = ({ creatorId, myId, isLoggedIn = false }) => {
    const [following, setFollowing] = useState(false);
    const [count, setCount] = useState(0);
    const [busy, setBusy] = useState(false);
    const { playSound } = useGamenics();

    useEffect(() => {
        if (!creatorId) return;
        api.getFollowStatus(creatorId).then((s) => { setFollowing(s.following); setCount(s.followerCount); });
    }, [creatorId]);

    if (!creatorId || (myId && creatorId === myId)) return null;

    const onClick = async () => {
        if (busy) return;
        if (!isLoggedIn) { toast({ title: 'ログインすると応援フォローできます' }); return; }
        setBusy(true);
        const next = !following;
        setFollowing(next); // 楽観的
        playSound(GamenicsEvent.TAP_CONFIRM);
        const res = await api.setFollow(creatorId, next);
        if (res.success) {
            if (typeof res.followerCount === 'number') setCount(res.followerCount);
            if (next) toast({ title: '応援フォローしました！' });
        } else {
            setFollowing(!next); // ロールバック
            toast({ title: 'フォローに失敗しました' });
        }
        setBusy(false);
    };

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={busy}
            className={`inline-flex items-center gap-1.5 font-display font-bold rounded-full border-2 border-ink px-3.5 py-1.5 text-sm transition-transform active:scale-95 disabled:opacity-60 ${
                following ? 'bg-ink text-cream' : 'bg-pop text-white hover:-translate-y-0.5'
            }`}
        >
            <Icon name={following ? 'check' : 'heart'} size={15} />
            {following ? '応援中' : '応援フォロー'}
            {count > 0 && <span className="opacity-80">· {count}</span>}
        </button>
    );
};
